<template>
  <div>
    <img :src="src" />
  </div>
</template>
<script>
import axios from 'axios'

export default {
  data () {
    return {
      src: this.data
    }
  },

  props: [ 'url', 'data' ],

  mounted () {
    axios.get(this.url).then(response  => {
      this.src = this.url
    })
  }
}
</script>